import service from '@/store/services/settings/shifts-service';

const state = {
    list: {},
    shift: {},
    meta: {}
};

const mutations = {
    SET_LIST: (state, list) => {
        state.list = list;
    },
    SET_RESOURCE: (state, shift) => {
        state.shift = shift;
    },
    SET_META: (state, meta) => {
        state.meta = meta;
    }
};

const actions = {
    list ({ commit, dispatch }, params = {}) {
        return service.list(params)
            .then(({ list, meta }) => {
                commit('SET_LIST', list);
                commit('SET_META', meta);
            });
    },
    get ({ commit, dispatch }, params) {
        return service.get(params)
            .then(shift => {
                commit('SET_RESOURCE', shift);
            });
    },
    show ({ commit, dispatch }, params) {
        return service.show(params)
            .then(shift => {
                commit('SET_RESOURCE', shift);
            });
    },
    add ({ commit, dispatch }, params) {
        return service.add(params)
            .then((shift) => {
                commit('SET_RESOURCE', shift);
            });
    },

    update ({ commit, dispatch }, params) {
        return service.update(params)
            .then((shift) => {
                commit('SET_RESOURCE', shift);
            });
    },

    destroy ({ commit, dispatch }, params) {
        return service.destroy(params);
    },
};

const getters = {
    list: state => state.list,
    listTotal: state => state.meta.page.total,
    shift: state => state.shift,
    dropdown: (state) => {
        return state.list.map(station => ({
            id: station.id,
            name: station.name,
            short_name: station.short_name,
            code: station.code
        }));
    }
};

const shifts = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default shifts;
